import { registerPlugin } from '@capacitor/core';
const mDNS = registerPlugin('mDNS', {
    web: () => import('./web').then((m) => new m.mDNSWeb()),
});
export * from './definitions';
export { mDNS };
//# sourceMappingURL=index.js.map